import { FullScreenPreloader } from "src/components/base/components/FullScreenPreloader";
import React from "react";
import { useRouterExt } from "src/components/reusable/hooks/useRouterExt";
import { global_config } from "src/shared/global_config";
import { routes } from "src/shared/routes";

export default function IndexPage() {
  const router = useRouterExt();

  React.useEffect(() => {
    // performing oAuth
    if (router?.query?.state) {
      const state = JSON.parse(window.atob(router.query.state as string)) as any; // prettier-ignore

      if (state.mlbcallback) {
        // logoutRedirectRoute comes from DEFAULT_APP_ROUTE_AFTER_LOGOUT, falling
        // back to landing for states created before the field existed
        const path = String(state.logoutRedirectRoute || routes.landing)
          .replace("[teamSchema]", state.teamSchema)
          .replace(/^\//, "");
        window.location.href = `${global_config.FRONTEND_URL}/${path}`;
        return;
      }

      window.location.href = `${global_config.FRONTEND_URL}/${state.teamSchema}/tmcallback?code=${router.query.code}&state=${router.query.state}`;
    }

    // performing logout
    if (router?.query?.logoutRedirectUrl) {
      window.open(router.query.logoutRedirectUrl as string, "_self");
    }
  }, []);

  return <FullScreenPreloader />;
}
